import "intersection-observer";
import { useRef, useEffect } from "react";

function useIntersectionObserver(callback, targetRef, rootMargin = "0px") {
  const savedCallback = useRef(null);
  const observer = useRef(null);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    observer.current = new IntersectionObserver(savedCallback.current, {
      rootMargin
    });
  }, [rootMargin]);

  useEffect(() => {
    observer.current.observe(targetRef.current);

    return () => {
      observer.current.unobserve(targetRef.current);
    };
  }, [targetRef.current]);
}

export default useIntersectionObserver;
